module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_point_02-7b4702a121a8d876cae1c2c4ea36c81a.jpg";